module.exports = __webpack_public_path__ + "static/media/ws03.3be6809f.webp";